import { useTranslation } from '@mc/i18n'
import { usePageData } from '../PageDataProvider'

export const useDynamicCategoryHeadlines = () => {
  const { slug, categorySavedDynamicHero } = usePageData()
  const { t } = useTranslation('@mc/next')

  const i18nHeadline = t(
    `categories.categoryPage.hero.category.${slug}.headline`,
  )
  const i18nSubheadline = t(
    `categories.categoryPage.hero.category.${slug}.subheadline`,
  )

  const headline = categorySavedDynamicHero?.header || i18nHeadline
  const subheadline = categorySavedDynamicHero?.subheader || i18nSubheadline
  const isDynamic = !!(
    categorySavedDynamicHero?.header || categorySavedDynamicHero?.subheader
  )

  return { headline, subheadline, isDynamic }
}
